export const api = {
  // 获取摄像机区域树
  queryCameraTree: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
  // 获取摄像机设备组
  queryCameraList: "/vas/video/queryRegionalEquipmentTree.json",
  // 查询录像流
  queryPlayBackVideoRtsp: "/vas/video/queryPlayBackVideoRtsp.json",
}
